import store from '@/store'

export default [
  {
    path: '/',
    redirect: to => {
      var role = store.getters['authorize/primaryRole']
      console.log('Redirect Role', role)
      return 'business'
    },
    component(resolve) {
      require(['@/views/root'], resolve)
    },
    children: [
      {
        path: 'notauthorized',
        component(resolve) {
          require(['@/views/error-pages/notauthorized'], resolve)
        },
        meta: { allowAnonymous: true }
      },
      {
        path: 'login',
        component(resolve) {
          require(['@/views/login'], resolve)
        },
        meta: { allowAnonymous: true }
      },
      {
        path: 'business',
        component(resolve) {
          require(['@/views/business'], resolve)
        }
      },
      {
        path: 'business/:action/:id?',
        component(resolve) {
          require(['@/views/business/business'], resolve)
        }
      },
      // Dashboard / Reporting
      {
        path: 'dashboard/requests',
        component(resolve) {
          require(['@/views/dashboard/requests'], resolve)
        }
      },
      {
        path: 'dashboard/statistics',
        component(resolve) {
          require(['@/views/dashboard/statistics'], resolve)
        }
      },
      {
        path: 'dashboard/devicestatistics',
        component(resolve) {
          require(['@/views/dashboard/devicestatistics'], resolve)
        }
      },
      {
        path: 'dashboard/activationcardstatistics',
        component(resolve) {
          require(['@/views/dashboard/activationcardstatistics'], resolve)
        }
      },
      {
        path: 'dashboard/businessaccountsinfo',
        component(resolve) {
          require(['@/views/dashboard/businessaccountsinfo'], resolve)
        }
      },
      {
        path: 'dashboard/deviceshipments',
        component(resolve) {
          require(['@/views/dashboard/deviceshipments'], resolve)
        }
      },
      {
        path: 'users',
        component(resolve) {
          require(['@/views/users'], resolve)
        }
      },
      {
        path: 'users/:action/:id?',
        component(resolve) {
          require(['@/views/users/user'], resolve)
        }
      },
      // Admin
      {
        path: 'admin/defaults',
        component(resolve) {
          require(['@/views/admin/defaults'], resolve)
        }
      },
      {
        path: 'admin/salesreps',
        component(resolve) {
          require(['@/views/admin/sales-reps'], resolve)
        }
      },
      {
        path: 'admin/translation',
        component(resolve) {
          require(['@/views/admin/translation'], resolve)
        }
      },
      {
        path: 'admin/message',
        component(resolve) {
          require(['@/views/admin/message'], resolve)
        }
      },
      {
        path: 'admin/devices',
        component(resolve) {
          require(['@/views/admin/devices'], resolve)
        }
      },
      {
        path: 'admin/device-detail/:id?',
        component(resolve) {
          require(['@/views/admin/device-detail'], resolve)
        }
      },
      {
        path: 'admin/device-file-detail/:id?',
        component(resolve) {
          require(['@/views/admin/device-file-detail'], resolve)
        }
      },
      {
        path: 'admin/device-files',
        component(resolve) {
          require(['@/views/admin/device-files'], resolve)
        }
      },
      {
        path: 'admin/integrations',
        component(resolve) {
          require(['@/views/admin/integrations'], resolve)
        }
      },
      {
        path: 'admin/integration-detail/:id?',
        component(resolve) {
          require(['@/views/admin/integration-detail'], resolve)
        }
      },
      {
        path: 'admin/maintenance',
        component(resolve) {
          require(['@/views/admin/maintenance'], resolve)
        }
      },
      {
        path: 'admin/report',
        component(resolve) {
          require(['@/views/admin/report'], resolve)
        }
      },
      {
        path: 'admin/chat',
        component(resolve) {
          require(['@/views/admin/chat'], resolve)
        }
      },
      {
        path: 'admin/calibrate',
        component(resolve) {
          require(['@/views/admin/calibrate'], resolve)
        }
      },
      {
        path: 'admin/mobile',
        component(resolve) {
          require(['@/views/admin/mobile'], resolve)
        }
      },
      {
        path: 'admin/files',
        component(resolve) {
          require(['@/views/admin/files'], resolve)
        }
      },
      {
        path: 'admin/scanpro',
        component(resolve) {
          require(['@/views/admin/scanpro'], resolve)
        }
      },
      {
        path: 'admin/makes',
        component(resolve) {
          require(['@/views/admin/makes'], resolve)
        }
      },
      {
        path: 'admin/calibration-homepage-message',
        component(resolve) {
          require(['@/views/admin/calibration-homepage-message'], resolve)
        }
      },
      {
        path: 'admin/openinghours/opening-hours',
        component(resolve) {
          require(['@/views/admin/openinghours/opening-hours'], resolve)
        }
      },
      {
        path: 'admin/openinghours/auditLog',
        component(resolve) {
          require(['@/views/admin/openinghours/audit-log'], resolve)
        }
      },
      {
        path: 'admin/rag/maintain-rag-ratings',
        component(resolve) {
          require(['@/views/admin/rag/maintain-rag-ratings'], resolve)
        }
      },
      {
        path: 'admin/rag/auditLog',
        component(resolve) {
          require(['@/views/admin/rag/audit-log'], resolve)
        }
      },
      {
        path: 'admin/rag/maintenance',
        component(resolve) {
          require(['@/views/admin/rag/maintain-rag-ratings'], resolve)
        }
      },
      {
        path: 'admin/rag/service-element-translation',
        component(resolve) {
          require(['@/views/admin/rag/service-element-translation'], resolve)
        }
      },
      {
        path: 'admin/rag/custom-message-translation',
        component(resolve) {
          require(['@/views/admin/rag/custom-message-translation'], resolve)
        }
      },
      {
        path: 'admin/issues',
        component(resolve) {
          require(['@/views/admin/issues'], resolve)
        }
      },
      {
        path: 'admin/business-profiles',
        component(resolve) {
          require(['@/views/admin/business-profiles'], resolve)
        }
      },
      {
        path: 'admin/connected-devices',
        component(resolve) {
          require(['@/views/admin/connected-devices'], resolve)
        }
      }
    ]
  },
  {
    path: '*',
    component(resolve) {
      require(['@/views/error-pages/404'], resolve)
    },
    meta: { allowAnonymous: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js